import { getLiveChatAutoTemplate, getVueLiveChatAutoTemplate } from "../../shortcodes/templates";

let liveChatShortcode = null;
const visualizeLiveAutoChat = content => {
  liveChatShortcode = content.querySelectorAll('[data-wrapper-id="live-chat-auto-shortcode"]');

  if (liveChatShortcode.length > 0) {
    liveChatShortcode.forEach(item => {
      item.innerHTML = getLiveChatAutoTemplate();
    });
  }
};

const serializeLiveAutoChat = content => {
  const liveChatShortcode = content.querySelectorAll('[data-wrapper-id="live-chat-auto-shortcode"]');
  if (liveChatShortcode.length > 0) {
    liveChatShortcode.forEach(item => {
      const liveChatData = item.getAttribute("data-live-chat-auto-data");
      item.innerHTML = getVueLiveChatAutoTemplate(liveChatData);
    });
  }
};

export { visualizeLiveAutoChat, serializeLiveAutoChat };
